import { lazy, Suspense } from "react";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { AdminProvider } from "@/contexts/AdminContext";

// Lazy load pages for code splitting
const Index = lazy(() => import("./pages/Index"));
const Auth = lazy(() => import("./pages/Auth"));
const SharedBlend = lazy(() => import("./pages/SharedBlend"));
const BlendFeedback = lazy(() => import("./pages/BlendFeedback"));
const Workshop = lazy(() => import("./pages/Workshop"));
const MaterialPage = lazy(() => import("./pages/MaterialPage"));
const MaterialsIndex = lazy(() => import("./pages/MaterialsIndex"));
const NotFound = lazy(() => import("./pages/NotFound"));

// Lazy load toast components to reduce initial bundle
const Toaster = lazy(() => import("@/components/ui/toaster").then(m => ({ default: m.Toaster })));
const Sonner = lazy(() => import("@/components/ui/sonner").then(m => ({ default: m.Toaster })));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <AdminProvider>
        <TooltipProvider>
          <Suspense fallback={null}>
            <Toaster />
            <Sonner />
          </Suspense>
          <BrowserRouter>
            <Suspense fallback={<div className="min-h-screen bg-background" />}>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/auth" element={<Auth />} />
                <Route path="/blends/:slug" element={<SharedBlend />} />
                <Route path="/blends/:slug/feedback" element={<BlendFeedback />} />
                <Route path="/workshop/:workshopSlug" element={<Workshop />} />
                <Route path="/materials" element={<MaterialsIndex />} />
                <Route path="/materials/:slug" element={<MaterialPage />} />
                {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </BrowserRouter>
        </TooltipProvider>
      </AdminProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
